module.exports = __webpack_public_path__ + "img/deposit_in_account.6be262af.svg";